module.exports = __webpack_public_path__ + "static/media/football-carousel-2.fa5be965.jpg";